import React from 'react';

import FirstHeader from '../components/firstHeader'
import Header from '../components/header'
import Fastbooking from '../components/fastbooking';
import Middlesection from '../components/middleSection'
import Footer from '../components/footer'

import PageFaqs from './pageFaqs';

const pageText = () =>{
  return (
    <div className='route-PageFaqs'>
      <FirstHeader />
      <Header isMenu={true} />

      <Fastbooking color='white'/>
      <Middlesection section='faqs'/>
      <PageFaqs />

      <Footer />
    </div>
  )
}

export default pageText;



// WEBPACK FOOTER //
// ./src/shared/routes/routeFaqs/index.js